import request from '@/http/request';

export function getAllNetworkTicketInfoList(data) {
  return request({
    url: '/api/v1/ops/get_network_alltk_info',
    method: 'post',
    data: data,
  });
}

export function upDateAllNetworkTicketInfoList(data) {
  return request({
    url: '/api/v1/ops/update_network_alltk_info',
    method: 'post',
    data: data,
  });
}
export function getNetworkDiagnoseList(data) {
  return request({
    url: '/api/v1/ops/get_network_diagnose_list',
    method: 'post',
    data: data,
  });
}

export function getNetworkChangeList(data) {
  return request({
    url: '/api/v1/ops/get_network_change_list',
    method: 'post',
    data: data,
  });
}

export function getNetworkRemoveList(data) {
  return request({
    url: '/api/v1/ops/get_network_remove_list',
    method: 'post',
    data: data,
  });
}

export function getNetworkPointList(data) {
  return request({
    url: '/api/v1/ops/get_network_point_list',
    method: 'post',
    data: data,
  });
}

export function getNetworkChainList(data) {
  return request({
    url: '/api/v1/ops/get_network_chain_list',
    method: 'post',
    data: data,
  });
}

export function getNetworkDeviceList(data) {
  return request({
    url: '/api/v1/ops/get_network_device_list',
    method: 'post',
    data: data,
  });
}

export function exportNetworkDiagnoseList(data) {
  return request({
    url: '/api/v1/ops/export_network_diagnose_list',
    method: 'post',
    data: data,
  });
}

export function exportNetworkChangeList(data) {
  return request({
    url: '/api/v1/ops/export_network_change_list',
    method: 'post',
    data: data,
  });
}

export function exportNetworkRemoveList(data) {
  return request({
    url: '/api/v1/ops/export_network_remove_list',
    method: 'post',
    data: data,
  });
}

export function exportNetworkPointList(data) {
  return request({
    url: '/api/v1/ops/export_network_point_list',
    method: 'post',
    data: data,
  });
}

export function exportNetworkChainList(data) {
  return request({
    url: '/api/v1/ops/export_network_chain_list',
    method: 'post',
    data: data,
  });
}
export function exportNetworkDeviceList(data) {
  return request({
    url: '/api/v1/ops/export_network_device_list',
    method: 'post',
    data: data,
  });
}

export function getOtherIdc(data) {
  return request({
    url: '/api/v1/ops/get_other_idc',
    method: 'post',
    data: data,
  });
}

export function exportOtherIdc(data) {
  return request({
    url: '/api/v1/ops/export_other_idc',
    method: 'post',
    data: data,
  });
}

export function getOtherSpecial(data) {
  return request({
    url: '/api/v1/ops/get_other_special',
    method: 'post',
    data: data,
  });
}

export function exportOtherSpecial(data) {
  return request({
    url: '/api/v1/ops/export_other_special',
    method: 'post',
    data: data,
  });
}

export function manpowerStabilizeHc(data) {
  return request({
    url: '/api/v1/ops/manpower_stabilize_hc',
    method: 'post',
    data: data,
  });
}

export function manpowerSpecial(data) {
  return request({
    url: '/api/v1/ops/manpower_special',
    method: 'post',
    data: data,
  });
}

export function manpowerEpiboly(data) {
  return request({
    url: '/api/v1/ops/manpower_epiboly',
    method: 'post',
    data: data,
  });
}

export function exportManpowerStabilizeHc(data) {
  return request({
    url: '/api/v1/ops/export_manpower_stabilize_hc',
    method: 'post',
    data: data,
  });
}

export function exportManpowerSpecial(data) {
  return request({
    url: '/api/v1/ops/export_manpower_special',
    method: 'post',
    data: data,
  });
}
export function exportManpowerEpiboly(data) {
  return request({
    url: '/api/v1/ops/export_manpower_epiboly',
    method: 'post',
    data: data,
  });
}
